export enum BookingStatusDeeplinkQueryParamsEnum {
    RecordLocator = "rl",
    Email = "em",
    LastName = "ln",
    Action = "act"
}

export enum BookingStatusDeeplinkActionEnum {
    Seats = "seats"
}